/**
 * Personal / Medication Consultation helpers.
 *
 * A product is considered "medical" (advice-required) when its `Category`
 * name matches one of the well-known medical category names below. This is a
 * name-based convention (no dedicated backend flag), so this list is the single
 * source of truth — update it here if the category naming changes.
 */
const MEDICAL_CATEGORY_NAMES = ["medical", "medikament", "medikamente"];

type CategoryLike = {
	name?: string | null;
} | null | undefined;

/**
 * Returns true when the given product category is an advice-required
 * ("medical") category. Matching is case-insensitive on the category name.
 */
export function isMedicalCategory(category: CategoryLike): boolean {
	if (!category?.name) {
		return false;
	}

	return MEDICAL_CATEGORY_NAMES.includes(category.name.trim().toLowerCase());
}
